import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

export function ColorPanel() {
  const { content, setPath } = useContent();
  if (!content) return null;
  return (
    <div className="color-panel show">
      <h4>Site colors</h4>
      <label>
        Accent (crimson)
        <input
          type="color"
          value={content.colors.crimson}
          onChange={(e) => setPath("colors.crimson", e.target.value)}
          data-testid={CMS.colorCrimsonInput}
        />
      </label>
      <label>
        Ink / text
        <input
          type="color"
          value={content.colors.ink}
          onChange={(e) => setPath("colors.ink", e.target.value)}
          data-testid={CMS.colorInkInput}
        />
      </label>
      <label>
        Background
        <input
          type="color"
          value={content.colors.parchment}
          onChange={(e) => setPath("colors.parchment", e.target.value)}
          data-testid={CMS.colorParchmentInput}
        />
      </label>
    </div>
  );
}
